<template>
  <div class="bank-detail">
    <div v-show="loading" class="loading">
      <img src="../assets/loading.gif" />
    </div>
    <div class="detail">
      <p class="detail-title">種別</p>
      <p class="p__style__4">
        {{ setAccountType(userInfoStore.bankInfo.account_type) }}
      </p>
      <p class="detail-title">銀行口座</p>
      <p class="p__style__4">
        {{ userInfoStore.bankInfo.bank_name }}
      </p>
      <p class="detail-title">口座種別</p>
      <p class="p__style__4">
        {{ setBankType(userInfoStore.bankInfo.bank_type) }}
      </p>
      <p class="detail-title">支店</p>
      <p class="p__style__4">
        {{ userInfoStore.bankInfo.bank_branch }}
      </p>
      <p class="detail-title">口座番号</p>
      <p class="p__style__4">
        {{ userInfoStore.bankInfo.bank_code }}
      </p>
      <p class="detail-title">口座名義</p>
      <p class="p__style__4">
        {{ userInfoStore.bankInfo.bank_account_name }}
      </p>
    </div>
    <div class="button-area">
      <common-button
        :data="{
          status: 0,
          button: `更新する`,
        }"
        style="max-width: 317px"
        @click="push()"
      ></common-button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";
import CommonButton from "./CommonButton.vue";
import { UserInfoStore } from "../store/UserInfoStore";
import { useRouter } from "vue-router";

const router = useRouter();
// const dateNum = 31;

const userInfoStore = UserInfoStore();
const loading = ref(false);
onMounted(async () => {
  if (!userInfoStore.bankInfo.id) {
    await userInfoStore.getBankInfo();
    document.title = "振込先銀行口座情報";
    // 登録済の情報を初期値で入れる
  }
});

function push() {
  router.push("/bank");
}

function setBankType(bankType: number) {
  if (!bankType) return "普通";
  else return "当座";
}
function setAccountType(accountType: number) {
  if (!accountType) return "個人";
  else return "法人";
}
</script>
<style lang="scss" scoped>
@import "../assets/style/_variables.scss";
@import "../assets/style/mixin.scss";

@mixin p__defalut($size, $line_height) {
  font-style: normal;
  font-weight: 300;
  font-size: $size;
  line-height: $line_height;
  color: #333333;
  margin: 0;
  white-space: pre-line;
}

.bank-detail {
  width: 100%;
  max-width: 480px;
  height: 100%;
  overflow-y: auto;
  max-height: 810px;
  scrollbar-gutter: stable;
}
.bank-detail::-webkit-scrollbar {
  display: none;
}
.header {
  text-align: center;
  width: 100%;
  padding-top: 10px;
}
.detail {
  margin-top: 49px;
  margin-bottom: 20px;
  border: 1px solid #e0e0e0;
  background: #fbfbfb;
  border-radius: 5px;
  margin-right: 20px;
  margin-left: 20px;
  padding-bottom: 15px;
  .detail-title {
    margin-bottom: 0;
    padding-left: 15px;
    font-style: normal;
    font-weight: 600;
    font-size: $FONT_SIZE_M;
    line-height: 21px;
  }
  p {
    margin-left: 15px;
    padding-right: 15px;
  }
  p:nth-child(even) {
    padding-bottom: 13px;
    padding-left: 13px;
    padding-top: 10px;
    margin-right: 15px;
    border-bottom: 1px dashed #e1e1e1;
  }
  p:nth-child(10) {
    border-bottom: none;
  }
}
.p__style__4 {
  @include p__defalut($FONT_SIZE_M, 21px);
}

label {
  font-size: $FONT_SIZE_M;
}
.form {
  width: 100%;
  max-width: 307px;
  margin: 0 auto;
  // font-family: $font-family-hiragino-gothic-pron;
  // text-align: center;
}
select {
  color: black;
  -webkit-appearance: none;
  appearance: none;
  background-image: url("../assets/arrow.svg");
  background-repeat: no-repeat;
  background-size: 16px 13px;
  background-position: right 18px center;
}
.error {
  color: red;
  text-align: center;
  margin: 0;
}
.title {
  margin-top: 40px;
  text-align: center;
  font-style: normal;
  font-weight: 600;
  font-size: $FONT_SIZE_L;
  line-height: 24px;
  height: 60px;
  width: 100%;
  max-width: 480px;
  background-color: rgba(8, 110, 182, 0.04);
  > p {
    margin: 0;
    padding-top: 18px;
  }
}
.button-area {
  width: 100%;
  max-width: 480px;
  height: 56px;
  margin: 0 auto;
  text-align: center;
  position: fixed;
  bottom: 80px;
  font-size: $FONT_SIZE_M;
  line-height: 21px;
}
.loading {
  margin: 0 auto;
  width: 50px;
  height: 50px;
}
.birth-area {
  width: 325px;
  justify-content: space-between;
  margin: 0 auto;
  padding-bottom: 16px;
  padding-top: 8px;
}
.number-field {
  width: 90px;
  height: 48px;
  border: 1px solid #777777;
  border-radius: 2px;
  background-color: $white;
  text-align: right;
  padding: 0 0 0 16px;
  font-size: $FONT_SIZE_M;
}
.name-area {
  width: 325px;
  justify-content: space-between;
  margin: 0 auto;
  padding-bottom: 16px;
  padding-top: 8px;
}
.name-text-field {
  width: 142px;
  height: 48px;
  padding: 0 0 0 8px;
  font-size: $FONT_SIZE_M;
}
.text-area {
  width: 307px;
  margin: 0 auto;
  padding-top: 8px;
}
.text-field {
  width: 307px;
  height: 48px;
  border: 1px solid #777777;
  border-radius: 2px;
  background-color: $white;
  padding: 0 0 0 8px;
  font-size: $FONT_SIZE_M;
}
.first-loading {
  display: flex;
  width: 96%;
  max-width: 460px;
  position: fixed;
  justify-content: center;
  top: 50%;
  img {
    width: 10%;
    height: 10%;
  }
}
</style>
